export default "<p>permission works!</p>\r\n"